import { Injectable } from '@angular/core';
import { QuestionnaireControllerService } from 'src/app/api/questionnaireApi/services';
import { EmployeeControllerService } from 'src/app/api/questionnaireApi/services';
// import { QuestionnaireControllerService } from '../../api/questionnaireApi/services/questionnaire-controller.service';
// import { EmployeeControllerService } from '../../api/questionnaireApi/services/employee-controller.service';
// 引入Excel下载需要的三个插件
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as moment from 'moment';
// 定义EXCEL的两个属性
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private questionnaireService: QuestionnaireControllerService,
    private employeerService: EmployeeControllerService,
  ) { }

  /**
   * 新增数据
  */
  addRecord(data) {
    const parms = {
      body: data
    };
    return this.questionnaireService.create(parms);
  }
  // getRecordList() {
  //   return this.questionnaireService.find();
  // }
  getRecordList(data) {
    const parms = {
      params: JSON.stringify(data)
    };
    return this.questionnaireService.getRecordList(parms);
  }
  // postlog(data){
  //   return this.pingService.create({body:JSON.stringify(data)});
  // }

  getEmplist(emplid) {
    return this.employeerService.find({filter:JSON.stringify({where:{'emplid':emplid}})});
  }
  // 表格中excel下载方法
  public exportTableAsExcelFile(data: any, excelName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(data);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelName);
  }

  // 数组文件的excel下载方法
  public exportArryAsExcelFile(data: any, excelName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    const today = this.getDate();
    FileSaver.saveAs(data, fileName + '_' + today + EXCEL_EXTENSION);
  }

  private getDate() {
    const today = new Date().getTime();
    return moment(today).format('YYYYMMDD');
  }
}
